import getField from '@form/formGenerator'

export const missionBillingSaveUrl = `${import.meta.env.VITE_API_URL}/api/mission-billings`

export const missionBillingFormObject = {
  id: null,
  min: null,
  max: null,
  cost: null,
  companyCost: null,
  coOwnershipCost: null
}

export const missionBillingFormFields = (missionBillingFormObject, updateFormObject, saveForm, errors, isLoading, t) => {
  const fields = [
    {
      type: 'number',
      name: 'min',
      label: t('labels.min'),
      value: missionBillingFormObject.min,
      key: 'missionBillingFormObject-min',
      cssClass: 'column is-12'
    },
    {
      type: 'number',
      name: 'max',
      label: t('labels.max'),
      value: missionBillingFormObject.max,
      key: 'missionBillingFormObject-max',
      cssClass: 'column is-12'
    },
    {
      type: 'number',
      name: 'cost',
      step: 0.5,
      label: t('labels.cost'),
      value: missionBillingFormObject.cost,
      key: 'missionBillingFormObject-cost',
      cssClass: 'column is-12'
    },
    {
      type: 'number',
      name: 'companyCost',
      step: 0.5,
      label: t('labels.company_cost'),
      value: missionBillingFormObject.companyCost,
      key: 'missionBillingFormObject-companyCost',
      cssClass: 'column is-12'
    },
    {
      type: 'number',
      step: 0.5,
      name: 'coOwnershipCost',
      label: t('labels.co_ownership_cost'),
      value: missionBillingFormObject.coOwnershipCost,
      key: 'missionBillingFormObject-coOwnershipCost',
      cssClass: 'column is-12'
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'missionBillingFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(missionBillingFormObject.id),
      key: 'missionBillingFormObject-id'
    },
    {
      type: 'hidden',
      name: 'billingType',
      value: parseInt(missionBillingFormObject.billingType),
      key: 'missionBillingFormObject-billingType'
    }, {
      type: 'hidden',
      name: 'mission',
      value: parseInt(missionBillingFormObject.mission),
      key: 'missionBillingFormObject-mission'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject)
  })
}